import { isUnifiedSearchView } from '../selectors/isUnifiedSearchView';
import { getListViewStore } from '../store/Store';

/**
 * In UnifiedSearch, it expands the itemPart with highest search relevance score,
 * and collapses all other item parts.
 * @param itemParts
 * @param conversationId
 */
export const getItemIdToExpandForSearch = (conversationId: string): string => {
    const conversationFromListView = getListViewStore().conversationItems.get(conversationId);
    return isUnifiedSearchView() && conversationFromListView?.globalItemIds[0];
};
